import React, { useState } from 'react';
import { Star } from 'lucide-react';

const fmt = (n) => n.toFixed(1).replace('.', ',');

// Stars show the book average; the reader's own score is shown next to it and can be changed anytime
export const BookStars = ({ book, myRating, onRate, size = 15 }) => {
  const [hover, setHover] = useState(0);
  const [status, setStatus] = useState(null);
  const [saving, setSaving] = useState(false);
  const avg = book.rating_avg || 0;
  const canRate = Boolean(onRate);
  const shown = hover || avg;

  const rate = async (n) => {
    if (!canRate || saving) return;
    setSaving(true);
    const ok = await onRate(book.id, n);
    setSaving(false);
    setHover(0);
    setStatus(ok ? 'saved' : 'error');
    setTimeout(() => setStatus(null), 2500);
  };

  return (
    <div data-testid={`book-stars-${book.id}`} onClick={(e) => e.stopPropagation()} onMouseLeave={() => setHover(0)}
      title={`Média ${fmt(avg)} de 5${canRate ? (myRating ? ` · sua nota: ${myRating} (clique para alterar)` : ' · clique para avaliar') : ''}`}
      style={{ display: 'inline-flex', flexWrap: 'wrap', alignItems: 'center', rowGap: 2, gap: 1, maxWidth: '100%', opacity: saving ? 0.6 : 1 }}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button key={n} type="button" disabled={!canRate || saving} data-testid={`book-star-${book.id}-${n}`} aria-label={`Dar nota ${n}`}
          onMouseEnter={() => canRate && setHover(n)} onClick={() => rate(n)}
          style={{ background: 'none', border: 'none', padding: 1, cursor: canRate ? 'pointer' : 'default', display: 'inline-flex', transition: 'transform 0.12s ease' }}>
          <Star style={{ width: size, height: size, color: '#f5b301', fill: n <= Math.round(shown) ? '#f5b301' : 'transparent' }} />
        </button>
      ))}
      {book.rating_count > 0 && <span data-testid={`book-rating-count-${book.id}`} style={{ fontSize: '0.72rem', color: '#a0aec0', marginLeft: 3, whiteSpace: 'nowrap' }}>{fmt(avg)} ({book.rating_count})</span>}
      {status === 'saved' && <span data-testid={`book-rating-saved-${book.id}`} style={{ fontSize: '0.7rem', color: '#2f855a', marginLeft: 5, fontWeight: 600, whiteSpace: 'nowrap' }}>Salvo!</span>}
      {status === 'error' && <span data-testid={`book-rating-error-${book.id}`} style={{ fontSize: '0.7rem', color: '#c53030', marginLeft: 5, whiteSpace: 'nowrap' }}>Erro, entre novamente</span>}
      {!status && canRate && myRating > 0 && <span data-testid={`book-my-rating-${book.id}`} style={{ fontSize: '0.7rem', color: '#b7791f', marginLeft: 5, whiteSpace: 'nowrap' }}>você: {myRating}★</span>}
    </div>
  );
};
